import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from 'components/app/common/FormUtils';
import useButtonsGenerator from 'components/app/common/functions/useButtonsGenerator';
import FormModal from 'components/app/common/FormModal';

import schema from './contractJsonSchema';
import DirectoryService from '../DirectoryService';
const jsonSchema = schema;

const Contract = ({ contract, profile, updateContract }) => {
  //const { identifier } = useParams();
  const [isLoadingPrediction, setIsLoadingPrediction] = useState(false);
  const updatedContract = {
    ...contract,
    salaryType: { label: contract.salaryType, value: contract.salaryType }
  };
  const data = updatedContract;
  const [modalShow, setModalShow] = useState(false);
  const [identifier, setIdentifier] = useState();
  const profileIdentifier = profile.identifier;
  useEffect(() => {
    setIdentifier(contract.identifier);
    console.log('Contract: ', contract);
    console.log('Contract data: ', data);
    console.log('Profile data: ', profile);
  }, []);

  const handleContractFormSubmit = async formData => {
    const grossSalary = formData.grossSalary  && typeof formData.grossSalary === 'string'
      ? parseFloat(formData.grossSalary.replace(/[£,]/g, '')) : formData.grossSalary;

    const updatedContract = {
      ...formData,
      salaryType: formData.salaryType.value,
      grossSalary: grossSalary ||  0.00,
      holidayTotalThisYear:
        formData.holidayBroughtForward + formData.holidayEntitlement
    };

    updateContract(profileIdentifier, updatedContract);
    console.log('Contract updated successfully');
    setModalShow(true);

    //ContractService.saveContract(formData)
    //  .then(response => {console.log(response); setModalShow(true)})
    //  .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Contract',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Contract');
      }
    }
  ];

  return (
    <>
      {modalShow && (
        <FormModal
          message={'Contract has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/social/directory/user-list"
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleContractFormSubmit}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

Contract.propTypes = {
  contract: PropTypes.shape({
    identifier: PropTypes.any,
    salaryType: PropTypes.any
  }),
  profile: PropTypes.shape({
    identifier: PropTypes.any
  }),
  updateContract: PropTypes.func
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onChange={handleChange}
      onSubmit={handleSubmit}
    >
      {formFields}
      {DirectoryService.isLoggedByHRAdmin() && (
        <Card.Footer>{buttonsGenerated}</Card.Footer>
      )}
    </Form>
  );
};

FormGeneratorWithData.propTypes = {
  buttonsConf: PropTypes.any,
  data: PropTypes.any,
  onSubmit: PropTypes.any
};
export default Contract;
